export default "__VITE_ASSET__YNSSW9y$__"